module.exports = __webpack_public_path__ + "img/Hilton Wien am Stadtpark 1.jpeg";